<template>
  <div class="infos-sign-in">
    <div class="step-0" v-if="signSteps.step === 0 || signSteps.step === 5">
      <h2 class="checkout-h2">Digite seu email para continuar</h2>
      <h4 class="checkout-h4 grey--text">
        Entre com seu email cadastrado ou continue como convidado.
      </h4>
      <div class="info-form">
        <v-form
          ref="formEmail"
          v-model="validEmail"
          @submit.prevent="
            () => {
              /* nunca executar */
            }
          "
        >
          <!-- <div style="max-height: 30px;" class="mt-2">
            <v-checkbox
              v-model="guestPurchase"
              label="Comprar como convidado"
              color="primary"
            ></v-checkbox>
          </div> -->

          <div class="bt-form">
            <v-text-field
              ref="signinEmail"
              @keyup.enter="checkEmailExists"
              :error-messages="errors.email()"
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
              outline
              type="email"
              v-model="email"
              :rules="emailRules"
              label="Email"
              append-icon="mail_outline"
            ></v-text-field>
          </div>

          <div class="d-flex align-center">
            <v-btn
              round
              outline
              color="primary"
              style="max-width: 103px"
              depressed
              class="normal-text"
              @click="backAStep"
            >
              Voltar
            </v-btn>
            <div class="btn-next-step">
              <v-btn
                block
                round
                depressed
                class="normal-text"
                :class="{ 'btn-disabled': $v.email.$invalid }"
                :color="!$v.email.$invalid ? 'primary' : 'info'"
                dark
                :loading="loadingEmail"
                @click="checkEmailExists"
                >Continuar</v-btn
              >
            </div>
          </div>
        </v-form>
      </div>
    </div>
    <div class="step-1" v-if="signSteps.step == 1">
      <h2 class="checkout-h2" v-if="userProps.name">
        Olá, {{ firstName(userProps) }}!
      </h2>
      <h2 class="checkout-h2">Digite sua senha para continuar</h2>
      <div class="info-form">
        <v-form
          ref="formPassword"
          v-model="validPassword"
          lazy-validation
          @submit.prevent="
            () => {
              /* nunca executar */
            }
          "
        >
          <div class="bt-form">
            <v-layout row wrap align-center justify-space-around mb-3>
              <v-flex xs6>
                <h4 class="checkout-h4 grey--text">{{ userProps.email }}</h4>
              </v-flex>
              <v-flex xs6 text-xs-right>
                <link-button @clicked="setSignSteps({ step: 0 })"
                  >Alterar</link-button
                >
              </v-flex>
            </v-layout>
            <v-text-field
              ref="signinPassword"
              v-model="password"
              @keyup.enter="submit"
              :error-messages="errors.password()"
              @input="$v.password.$touch()"
              outline
              label="Senha"
              :append-icon="show ? 'visibility' : 'visibility_off'"
              :type="show ? 'text' : 'password'"
              @click:append="show = !show"
              required
            ></v-text-field>
          </div>
          <div class="d-flex align-center">
            <v-btn
              round
              outline
              color="primary"
              style="max-width: 103px"
              depressed
              class="normal-text"
              @click="backAStep"
            >
              Voltar
            </v-btn>
            <div class="btn-next-step">
              <v-btn
                block
                round
                depressed
                class="normal-text"
                :class="{ 'btn-disabled': $v.password.$invalid }"
                :color="!$v.password.$invalid ? 'primary' : 'info'"
                dark
                @click="submit"
                >Continuar</v-btn
              >
            </div>
          </div>
          <link-button
            class="w100 text-xs-center mt-2"
            @clicked="forgotPassword(email)"
            >Esqueci minha senha</link-button
          >
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { required, minLength, email } from 'vuelidate/lib/validators';
import { setTimeout } from 'timers';
import LinkButton from '@/components/UI/LinkButton';
import validationMixin from '@/mixins/validationMixin';

export default {
  components: {
    LinkButton,
  },
  mixins: [validationMixin],
  data: () => ({
    validEmail: false,
    validPassword: false,
    show: false,
    loadingEmail: false,
    password: '',
    dataByEmail: null,
    errorMessagesPasswords: '',
  }),
  validations() {
    return {
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(6),
      },
    };
  },
  computed: {
    ...mapGetters({
      userProps: 'userProps',
      signSteps: 'signSteps',
      clientToken: 'clientToken',
      body: 'body',
      currentStep: 'currentStep',
      cupomData: 'cupomData',
    }),
    email: {
      get() {
        return this.userProps.email;
      },
      set(val) {
        this.setUserProps({ ...this.userProps, email: val });
      },
    },

    isSponsorCampaign() {
      return (
        this.cupomData &&
        this.cupomData.campaign_type &&
        this.cupomData.campaign_type === 'P'
      );
    },

    errors() {
      return {
        email: () => {
          const errors = [];
          if (!this.$v.email.$dirty) return errors;
          !this.$v.email.required && errors.push('Campo obrigatório.');
          !this.$v.email.email && errors.push('E-mail inválido.');
          return errors;
        },
        password: () => {
          const errors = [];
          if (!this.$v.password.$dirty) return errors;
          !this.$v.password.required && errors.push('Campo obrigatório.');
          !this.$v.password.minLength && errors.push('Mínimo de 6 caracteres');
          return errors;
        },
      };
    },
  },
  methods: {
    ...mapActions({
      setUserProps: 'setUserProps',
      setSignSteps: 'setSignSteps',
      emailExists: 'emailExists',
      forgotPassword: 'forgotPassword',
    }),
    backAStep() {
      this.$store.dispatch('backAStep');
    },
    firstName(name) {
      return this.userProps.name.split(' ')[0];
    },
    async checkEmailExists() {
      if (!this.validEmail) {
        return;
      }

      this.loadingEmail = true;

      const data = await this.emailExists(this.email);
      await this.$store.dispatch('registerUserEmail', {
        codigo_evento: this.$store.getters.eventID,
        email: this.email,
        codigo_pedido: this.body.codigo_pedido,
      });
      await this.setUserProps({ ...this.userProps, email: this.email });
      await this.$store.dispatch('nextStep');

      let step = 0;
      if (!data.available) {
        step = 1; // signin
      } else {
        step = 5; // non-registered
      }

      await this.setSignSteps({
        step,
      });
      this.loadingEmail = false;
    },
    async submit() {
      if (this.$refs.formPassword.validate()) {
        try {
          const data = {
            username: this.email,
            password: this.password,
          };
          await this.$store.dispatch('clientLogin', data);

          this.setSignSteps({ logged: true, signForm: false, step: 0 });
          this.$store.dispatch('nextStep');
        } catch (error) {
          this.password = '';
          this.setSignSteps({ logged: false, signForm: true, step: 1 });
          setTimeout(() => {
            this.$refs.signinPassword.focus();
          }, 200);
        }
      }
    },
    submitLogged() {
      const eventState = {
        id: this.$store.getters.eventID,
        userToken: this.$store.getters.clientToken,
        step: 3,
      };
      this.$store.dispatch('saveCheckoutState', eventState);
      this.$store.dispatch('nextStep');
    },
    logout() {
      this.$store.dispatch('eraseClientToken');
      this.$store.dispatch('sendPostMessage', {
        open: true,
        logged: false,
        userToken: null,
        logout: true,
      });
    },
    clear() {
      this.$refs.form.reset();
    },
    mountStep() {
      const { step } = this.signSteps;
      !!this.$refs.formEmail && this.$refs.formEmail.resetValidation();
      !!this.$refs.formPassword && this.$refs.formPassword.resetValidation();

      switch (step) {
        case 0:
          this.$refs.signinEmail.focus();
          break;
        case 1:
          this.$refs.signinPassword.focus();
          break;
      }
    },
  },
  watch: {
    'signSteps.step': function(val) {
      if (val === 0) {
        // !!this.$refs.formEmail && this.$refs.formEmail.resetValidation()
        setTimeout(() => {
          this.$refs.signinEmail.focus();
        }, 200);
      }

      if (val === 1) {
        // !!this.$refs.formPassword && this.$refs.formPassword.resetValidation()
        setTimeout(() => {
          this.$refs.signinPassword.focus();
        }, 200);
      }
    },
  },
  mounted() {
    this.mountStep();
  },
};
</script>

<style lang="stylus">
@import '~@/assets/infos/forms/infos-sign-in.styl';
</style>
